import { Serializable } from '../../../core/models/serializable';

export class OccupationCategorySelection
  implements Serializable<OccupationCategorySelection>
{
  fromObject(object: any): OccupationCategorySelection {
    Object.assign(this, object);
    return this;
  }
  toObject() {
    throw new Error('Method not implemented.');
  }

  public occupationCategoryId: number;
  public name: string;
  public isChecked: boolean;
}
